import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-825d69ba")

_pushScopeId("data-v-825d69ba")
const _hoisted_1 = { class: "card-component" }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      (_ctx.title)
        ? (_openBlock(), _createBlock("h6", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "header", {}, undefined, true)
    ]),
    _createVNode("main", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode("footer", null, [
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ])
  ]))
})